var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("app-browse", {
        attrs: {
          "button-bar-items": _vm.buttonBarItems,
          "data-source": _vm.dataSource,
          "controls-disabled": false,
          "selected-items": _vm.selectedItems,
          "url-query-params": "",
        },
        on: {
          showStockScanDifference: function ($event) {
            return _vm.showStockScanDifference()
          },
        },
      }),
      _c(
        "w-modal",
        {
          attrs: { "full-height": "" },
          model: {
            value: _vm.scanStockDifferenceModal,
            callback: function ($$v) {
              _vm.scanStockDifferenceModal = $$v
            },
            expression: "scanStockDifferenceModal",
          },
        },
        [
          _c("app-scan-difference", {
            on: {
              close: function ($event) {
                _vm.scanStockDifferenceModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }